<button
    type="button"
    #popover="ngbPopover"
    class="btn text-reset"
    [autoClose]="'outside'"
    [ngbPopover]="popoverContent"
    [popoverTitle]="popHeader"
    [placement]="popPlacement">
    <i *ngIf="popBtn; else templateText" class="{{ popBtn }}"  aria-hidden="true"></i>
    <ng-template #templateText>
        <ng-content></ng-content>
    </ng-template>
</button>